import { matchPath } from 'react-router';

/**
 * Build a stack entry from a route and a live pathname.
 *
 * Returns null when:
 *   - the route is missing,
 *   - the route has no `additional.breadcrumb` config,
 *   - the pathname does not match the route template.
 *
 * Labels are NOT resolved here — they are computed lazily in
 * `selectBreadcrumbsResolved` so dynamic entity names stay reactive
 * to Redux updates without race conditions.
 */
export const resolveBreadcrumb = (route, pathname) => {
  if (!route || !route.additional?.breadcrumb) return null;
  const match = matchPath(route.path, pathname);
  if (!match) return null;
  return {
    pathTemplate: route.path,
    resolvedPath: pathname,
    params: match.params || {},
    isRoot: !!route.additional.breadcrumb.isRoot,
  };
};
